module.exports = __webpack_public_path__ + "images/active-drive.5769c9027976cac5ed80931ddf6e319c.png";